var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 48.041,
    viewBox: "0 0 40 48.041",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_369",
    "data-name": "Groupe 369",
    transform: "translate(-258.429 -134.695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_405-2",
    "data-name": "Groupe 405-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_572",
    "data-name": "Trac\\xE9 572",
    d: "M292.429,182.736h-28a6.006,6.006,0,0,1-6-6v-36a6.007,6.007,0,0,1,6-6h.012c9.436.06,14.747,0,17.6-.028,3.556-.038,3.623-.038,4.274.612.408.407,5.136,6.359,6.05,7.514,6.063,7.662,6.063,7.753,6.063,8.623v25.279A6.007,6.007,0,0,1,292.429,182.736Zm-28-44a2,2,0,0,0-2,2v36a2,2,0,0,0,2,2h28a2,2,0,0,0,2-2V152.03c-1.459-2.04-8.434-10.826-10.492-13.338-.461,0-1.112.008-1.853.016C279.22,138.739,273.888,138.794,264.424,138.736Z",
    fill: "#3f82ef"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_546",
    "data-name": "Trac\\xE9 546",
    d: "M271.637,163.775l5.677,9.961H266.2Z",
    fill: "#3f82ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Soustraction_15",
    "data-name": "Soustraction 15",
    d: "M290.654,173.736H279.565l-4.4-7.6,5.39-8.7,10.1,16.3Z",
    fill: "#3f82ef"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_293",
    "data-name": "Ellipse 293",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(268.76 151.436)",
    fill: "#3f82ef"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.75435577d12e75b8411045c6db5c3fca.svg";
export { ForwardRef as ReactComponent };